module.exports = __webpack_public_path__ + "static/media/gem.2f7e010b.svg";